import { VIDEO_PAGE_KEY } from 'src/pages/pagesKeys';

import GenericItemPage, { DOM_ID } from 'src/pages/generic-item-page/GenericItemPage';
import VideoContent from './VideoContent';

export default {
  key: VIDEO_PAGE_KEY,
  path: '/video',
  elId: DOM_ID,
  className: 'video-page',
  component: GenericItemPage,
  childComponent: VideoContent,
  relatedDataToFetch: [],
};
